import { useEffect, useState } from "react";
import axios from "../api/axiosInstance";

export default function AdminRxPanel() {
  const [rxs, setRxs] = useState([]);
const [previewImage, setPreviewImage] = useState(null);
const [stats, setStats] = useState([]);
const loadStats = async () => {
  const res = await axios.get("/admin/pharmacist-rx-stats/");
  setStats(res.data);

};

useEffect(() => {
  loadStats();
}, []);
  useEffect(() => {
    axios.get("/rx/internal-list/").then(res => setRxs(res.data));
  }, []);
const formatDateTime = (dt) => {
  if (!dt) return "—";
  const d = new Date(dt);
  return d.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

  return (
    <div>
      <h2>Admin RX Panel</h2>
<h3>📊 Pharmacist Performance</h3>

<table border="1" width="100%" style={{marginBottom:"20px"}}>
  <thead>
    <tr>
      <th>Pharmacist</th>
      <th>Accepted</th>
      <th>Rejected</th>
      <th>Completed</th>
    </tr>
  </thead>
  <tbody>
    {stats.map((p, i) => (
  <tr key={p.handled_by__id || p.name || i}>
        <td>{p.name|| "—"}</td>
        <td>{p.accepted}</td>
        <td>{p.rejected}</td>
        <td>{p.completed}</td>
      </tr>
    ))}
  </tbody>
</table>

{rxs.map((rx, i) => (
  <div key={rx.id || i} style={{ border: "1px solid #999", padding: 12, marginBottom: 12 }}>
    <p><b>Order ID: #{rx.id}</b></p>
    <p><b>{rx.customer_name}</b> ({rx.profile_phone})</p>
    <p>Callback: {rx.callback_phone}</p>
    <p>Hospital: {rx.hospital_name || "Outside"}</p>
    <p>Status: {rx.status}</p>
    <p>Handled By: {rx.handled_by_name || "Not yet handled"}</p>
    <p>📅 Date & Time: {formatDateTime(rx.created_at)}</p>



{rx.original_price && (
  <p>🧾 Original Price: ₹{rx.original_price}</p>
)}

{rx.customer_discount > 0 && (
  <p style={{ color: "green" }}>
    🎁 Customer Discount: −₹{rx.customer_discount}
  </p>
)}

{rx.final_price && (
  <p>💊 Final Price (User Paid): ₹{rx.final_price}</p>
)}

{rx.delivery_charge !== null ? (
  <p>🚚 Delivery Charge: ₹{rx.delivery_charge}</p>
) : (
  <p style={{ color: "#999" }}>🚚 Delivery Charge: Not calculated yet</p>
)}
{rx.medicine_days && (
  <p>🧪 Medicine For: {rx.medicine_days} days</p>
)}

{rx.days && (
  <p>🚚 Delivery in: {rx.days} days</p>
)}

{rx.app_profit && (
  <p style={{ color: "purple" }}>
    🏦 App Earning: ₹{rx.app_profit}
  </p>
)}

{rx.hospital_amount && (
  <p style={{ color: "blue" }}>
    🏥 Payable to Hospital: ₹{rx.hospital_amount}
  </p>
)}


{/* 🚚 Delivery Charge – ALWAYS SEPARATE */}
{rx.delivery_charge !== null && (
  <p>🚚 Delivery Charge: ₹{rx.delivery_charge}</p>
)}








    {/* Pricing */}
    {rx.quoted_price && (
      <p>💊 Price: ₹{rx.quoted_price}</p>
    )}

<p>
  🚚 Delivery Status:{" "}
  <b
    style={{
      color:
        rx.delivery_status === "Delivered"
          ? "green"
          : rx.delivery_status === "Rejected" || rx.delivery_status === "Cancelled"
          ? "red"
          : rx.delivery_status === "Out for Delivery"
          ? "orange"
          : "blue",
    }}
  >
    {rx.delivery_status}
  </b>
</p>
{rx.delivery_boy_name && (
  <p style={{ color: "#444" }}>
    🚴 Delivery Partner: <b>{rx.delivery_boy_name}</b>
  </p>
)}


    {/* Rejection reason */}
    {rx.status === "rejected" && rx.admin_note && (
      <p style={{color:"red"}}>❌ Rejection Reason: {rx.admin_note}</p>
    )}

{/* 📄 PRESCRIPTIONS */}
{rx?.prescription_files?.filter(Boolean).map((p, i) => (
  <div
    key={i}   // 👈 safest
    style={{
      position: "relative",
      display: "inline-block"
    }}
  >
    <img
      src={p}
      alt="prescription"
      onClick={() => setPreviewImage(p)}
      style={{
        width: 80,
        height: 80,
        objectFit: "cover",
        borderRadius: 8,
        cursor: "pointer",
        border: "1px solid #ccc",
      }}
    />

    <a
      href={p}
      target="_blank"
      rel="noreferrer"
      download
      style={{
        position: "absolute",
        bottom: 4,
        right: 4,
        background: "rgba(0,0,0,0.7)",
        color: "#fff",
        padding: "2px 6px",
        fontSize: 10,
        borderRadius: 4,
        textDecoration: "none",
      }}
    >
      ⬇
    </a>
  </div>
))}



    {rx.bill_image && (
  <div style={{ marginTop: 10 }}>
    <p><b>🧾 Bill</b></p>

    <div style={{ position: "relative", display: "inline-block" }}>
      
      <img
        src={rx.bill_image}
        alt="bill"
        onClick={() => setPreviewImage(rx.bill_image)}
        style={{
          width: 120,
          borderRadius: 8,
          cursor: "pointer",
          boxShadow: "0 2px 6px rgba(0,0,0,0.2)"
        }}
      />

      <a
        href={rx.bill_image}
        target="_blank"
        rel="noreferrer"
        style={{
          position: "absolute",
          bottom: 5,
          right: 5,
          background: "rgba(0,0,0,0.6)",
          color: "#fff",
          padding: "2px 6px",
          fontSize: 11,
          borderRadius: 4,
          textDecoration: "none"
        }}
      >
        ⬇
      </a>
    </div>
  </div>
)}



{previewImage && (
  <div
    onClick={() => setPreviewImage(null)}
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0,0,0,0.8)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999
    }}
  >
    <img
      src={previewImage}
      onClick={(e) => e.stopPropagation()}
      alt="preview"
      style={{
        maxWidth: "90%",
        maxHeight: "90%",
        borderRadius: 10
      }}
    />
  </div>
)}




  </div>
))}

    </div>
  );
}
		